import { attachAuthInterceptors } from '@repo/auth/axios';
import axios from 'axios';
import { setupCache } from 'axios-cache-interceptor';

import { authClient } from 'src/app/auth/auth-client';
import { getLocale } from 'src/packages/language/utils';

const instance = axios.create({
  headers: {
    'content-type': 'application/json',
  },
});

const wellLogsWidgetAgent = setupCache(instance, {
  headerInterpreter: () => {
    return 'not enough headers';
  },
  ttl: 1000 * 10,
});

attachAuthInterceptors(wellLogsWidgetAgent, authClient);

wellLogsWidgetAgent.interceptors.request.use((config) => {
  config.headers.set('accept-language', getLocale());
  return config;
});

export { wellLogsWidgetAgent };
